<template>
  <div class>
    <cContentEdit
      :canEdit="false"
      :editMode="editMode"
      :title="$t('cHotelLang.title')"
    >
      <div>
        <CRow>
          <CCol>
            <cTextInputComponent
              :label="$t('cHotelLang.searchPl')"
              @input="onLangsSearch"
              :placeholder="$t('cHotelLang.searchPl')"
            ></cTextInputComponent>
          </CCol>
          <CCol style="    padding-top: 28px;">
            <CButton @click="onShowMore">
              ShowMore
            </CButton>
          </CCol>
          <CCol style="    padding-top: 28px;">
            <label>
              <input
                type="checkbox"
                v-model="isSelectAll"
                @change="selectAllLangs(isSelectAll)"
              />

              select all
            </label>
          </CCol>
        </CRow>

        <CRow>
          <ul v-if="lsAllLangs && lsAllLangs.length">
            <li
              v-for="(lang, index) in lsAllLangs"
              :key="index + 'amnities'"
            >
              <label>
                <input
                  @input="selectLang(lang)"
                  type="checkbox"
                  :checked="
                    lsSelectedLangs.some(
                      (val) => val.langcode == lang.langcode
                    )
                  "
                />
                {{ lang.langName }}
              </label>
            </li>
          </ul>
        </CRow>
      </div>
    </cContentEdit>
  </div>
</template>

<script>
import { ValidationObserver } from "vee-validate";
import { COMPONENT_NAME, PATHNAME } from "../../../../util/constants";
import router, { navigate } from "../../../../router/index";

import { mapGetters, mapActions } from "vuex";
import Logger from "../../../../services/logger";

import {
  VALIDATE_SUCCESS_RES,
  getErrorMessage,
} from "../../../../util/apiValidate";
import {
  handleJWT,
  getErrorAlertValue,
  addClassToBody,
  removeClassBody,
  OrderByList,
  removeDuplicates,
  cloneDeep,
} from "../../../../util/util";
import {
  LOG_TYPE,
  FILE_NAME,
  HTTP_CODES,
  API_VALUES,
} from "../../../../config/API_DATA";
import BaseConfiguration from "../../../../config/base";
import apiHmsGetAllLang from "../../../../services/apiHmsGetAllLang";

import cTextInputComponent from "../../../../components/form/cTextInputComponent";
import cContentEdit from "../../../../components/hms/manage/hotelInfo/cContentEdit";
export default {
  name: COMPONENT_NAME.C_ROOM_LANG,

  components: {
    cContentEdit,
    cTextInputComponent,
  },

  props: {
    showEdit: {
      type: Boolean,
      default: false,
    },
  },

  data: () => {
    return {
      editMode: false,
      alertValue: null,
      canEdit: true,
      allLangsRes: [],

      isSelectAll: false,

      showMore: false,

      lsAllLangs: [],
      lsSelectedLangs: [],
    };
  },

  computed: {
    ...mapGetters("sHotelInfo", {
      hotelObj: "GET_HOTEL_OBJ",
    }),
  },

  methods: {
    showAlert(val) {
      this.alertValue = val;
    },

    selectAllLangs(val) {
      try {
        if (BaseConfiguration.isDebug) console.log("selectAllLangs");

        if (val) {
          this.lsSelectedLangs = cloneDeep(this.allLangsRes);
          this.lsAllLangs = cloneDeep(this.allLangsRes);
        } else {
          this.lsSelectedLangs = [];
        }
        this.$emit("onSelect", this.lsSelectedLangs);
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.C_ROOM_LANG,
          "error in selectAllLangs",
          err.toString(),
          "selectAllLangs",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    onShowMore() {
      try {
        if (BaseConfiguration.isDebug) console.log("onShowMore");
        this.showMore = !this.showMore;

        if (this.showMore) {
          this.lsAllLangs = cloneDeep(this.allLangsRes);
        } else {
          this.lsAllLangs = this.allLangsRes.slice(0, 10);
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.C_ROOM_LANG,
          "error in onShowMore",
          err.toString(),
          "onShowMore",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    selectLang(pLang) {
      try {
        if (BaseConfiguration.isDebug) console.log("selectLang");

        if (pLang) {
          if (
            this.lsSelectedLangs.find(
              (bedType) => bedType.langcode == pLang.langcode
            )
          ) {
            this.lsSelectedLangs = this.lsSelectedLangs.filter(
              (bedType) => bedType.langcode != pLang.langcode
            );
          } else {
            this.lsSelectedLangs.push(pLang);
          }
          this.$emit("onSelect", this.lsSelectedLangs);
        } else {
          throw "invalid lang";
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.C_ROOM_LANG,
          "error in selectLang",
          err.toString(),
          "selectLang",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    onLangsSearch(pPartialLangName) {
      try {
        if (BaseConfiguration.isDebug) console.log("onLangsSearch");

        if (this.allLangsRes && this.allLangsRes.length) {
          this.lsAllLangs = this.allLangsRes.filter((bedType) =>
            bedType.langName
              .toString().trim()
              .toLowerCase()
              .includes(pPartialLangName.toString().trim().toLowerCase())
          );
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.C_ROOM_LANG,
          "error in onLangsSearch",
          err.toString(),
          "onLangsSearch",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    async getAllLang() {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("getAllLang");

        if (this.hotelObj) {
          let allLangReq = apiHmsGetAllLang.buildRequest(
            this.hotelObj.hotelid
          );

          if (allLangReq) {
            // this.SET_AGENCY_REQ(getRoutesRequest); //save req in store
            let allLangRes = await apiHmsGetAllLang.getResponse(
              allLangReq
            );

            if (VALIDATE_SUCCESS_RES(allLangRes)) {
              this.showAlert(null);
              retValue = allLangRes.data.data;
          
            } else {
              let error = getErrorMessage(allLangRes);
              this.showAlert(error);
              let isJwt = handleJWT(error);
              if (!isJwt) {
                getErrorAlertValue(error);
              }
            }
          }
        } else {
          throw "invalid hotel obj";
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.C_ROOM_LANG,
          "error in getAllLang",
          err.toString(),
          "getAllLang",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },
  },

  async created() {
    try {
      if (BaseConfiguration.isDebug) console.log("created");

      this.editMode = this.showEdit;
      let allLangRes = await this.getAllLang();
      if (allLangRes && allLangRes.length) {
        this.allLangsRes = allLangRes;
        this.lsAllLangs = allLangRes.slice(0, 10);
      }
    } catch (err) {
      let body = Logger.buildRequest(
        FILE_NAME.C_ROOM_LANG,
        "error in created",
        err.toString(),
        "created",
        LOG_TYPE.ERROR
      );
      Logger.getResponse(body);
    }
  },
};
</script>

<style></style>
